/**
 * Palmare reservation / restock modal — webhook routing.
 *
 * Replace these three constants with the real Make.com webhook URLs before
 * going live. Each flow has its OWN scenario/webhook — do not reuse one URL
 * for all three, the payload shapes and downstream actions differ per flow.
 */
var PALMARE_RESTOCK_WEBHOOK_URL = 'https://hook.eu1.make.com/t74s6wjr2dxwikfa5plbcl58q0hi83mg'; // Flujo Restock (scenario 6712696)
var PALMARE_VIP_WEBHOOK_URL = 'https://hook.eu1.make.com/ydf3m7bkoxdxilk4hxexofdkjosqbp2j'; // Flujo Landing A / VIP (scenario 6906411)
var PALMARE_GUEST_WEBHOOK_URL = 'https://hook.eu1.make.com/n5ejwp0dn183z6ucw13edownqyl48ro2'; // Flujo Landing B / Guest-Meta (scenario 6906439)

(function () {
  var SOURCE_STORAGE_KEY = 'palmare_source';
  var CONTACT_STORAGE_KEY = 'palmare_contact_info';
  var PREFILLABLE_FIELDS = ['email', 'instagram', 'phone'];

  // Capture ?source=vip / ?source=guest on any page load and persist it for
  // the rest of the session, so the modal still routes correctly if it's
  // opened later on a page/URL that no longer carries the query param.
  function captureSourceFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var source = params.get('source');
    if (source === 'vip' || source === 'guest') {
      try {
        sessionStorage.setItem(SOURCE_STORAGE_KEY, source);
      } catch (e) {
        /* sessionStorage unavailable (privacy mode) — routing falls back to guest */
      }
    }
  }

  function getSource() {
    try {
      return sessionStorage.getItem(SOURCE_STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  // Remembers the contact fields (not size — that's per-product) after a
  // successful submission, so reserving a 2nd/3rd product in the same
  // browser only requires re-picking a size and clicking submit once.
  function saveContactInfo(payload) {
    var data = {};
    PREFILLABLE_FIELDS.forEach(function (field) {
      if (payload[field]) data[field] = payload[field];
    });
    if (!Object.keys(data).length) return;
    try {
      localStorage.setItem(CONTACT_STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      /* localStorage unavailable (privacy mode) — next modal just opens blank */
    }
  }

  function getSavedContactInfo() {
    try {
      var raw = localStorage.getItem(CONTACT_STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  // Fills email/instagram/phone from a previous successful reservation.
  // Never overwrites a field the user (or the page) already populated.
  function prefillContactFields(modal) {
    var saved = getSavedContactInfo();
    if (!saved) return;
    var form = modal.querySelector('.palmare-reservation-modal__form');
    if (!form) return;
    PREFILLABLE_FIELDS.forEach(function (field) {
      var input = form.querySelector('[name="' + field + '"]');
      if (input && !input.value && saved[field]) {
        input.value = saved[field];
      }
    });
  }

  // modal-opener's own click handler (assets/global.js) is what actually
  // shows the dialog; this delegated listener just piggybacks on the same
  // click to prefill it first — the modal's DOM already exists (just
  // CSS-hidden) at click time, so ordering relative to the theme's own
  // handler doesn't matter.
  function handleTriggerClick(event) {
    var opener = event.target.closest('modal-opener');
    if (!opener) return;
    var selector = opener.getAttribute('data-modal');
    if (!selector) return;
    var modal = document.querySelector(selector);
    if (modal && modal.classList.contains('palmare-reservation-modal')) {
      prefillContactFields(modal);
      prefillSizeFromPage(modal);
    }
  }

  // Lee el selector de variante DE LA PAGINA (el picker de la PDP). Excluye
  // explicitamente el campo propio del modal via :not([data-palmare-size]):
  // ese select se llama "size" y si no, en la PDP, podria devolverse a si
  // mismo en lugar del picker real.
  function getPageSize() {
    var checkedRadio = document.querySelector(
      'input[type="radio"][name*="Talla" i]:checked, input[type="radio"][name*="Size" i]:checked'
    );
    if (checkedRadio) return checkedRadio.value;

    var sizeSelect = document.querySelector(
      'select[name*="Talla" i]:not([data-palmare-size]), select[name*="Size" i]:not([data-palmare-size])'
    );
    if (sizeSelect) return sizeSelect.value;

    return '';
  }

  // El selector propio del modal manda siempre que exista (tarjetas y
  // landings, donde no hay picker en pantalla). Si el modal no lo lleva
  // — flujo restock de SQUADRA 34 — se conserva exactamente el
  // comportamiento anterior: leer el picker de la pagina.
  function getSelectedSize(form) {
    var ownField = form ? form.querySelector('[data-palmare-size]') : null;
    if (ownField) return ownField.value;
    return getPageSize();
  }

  // En la PDP el usuario ya ha elegido talla en el picker antes de abrir el
  // modal, asi que se arrastra como preseleccion. En tarjetas y landings no
  // hay picker, getPageSize() devuelve '' y el campo se queda en blanco
  // obligando a elegir. Solo se acepta un valor que el propio modal ofrezca.
  function prefillSizeFromPage(modal) {
    var field = modal.querySelector('[data-palmare-size]');
    if (!field || field.value) return;
    var pageSize = getPageSize();
    if (!pageSize) return;
    for (var i = 0; i < field.options.length; i++) {
      if (field.options[i].value === pageSize) {
        field.value = pageSize;
        return;
      }
    }
  }

  function resolveWebhookUrl(form) {
    if (form.dataset.reservationType === 'restock') {
      return PALMARE_RESTOCK_WEBHOOK_URL;
    }
    return getSource() === 'vip' ? PALMARE_VIP_WEBHOOK_URL : PALMARE_GUEST_WEBHOOK_URL;
  }

  function handleSubmit(event) {
    var form = event.target.closest('.palmare-reservation-modal__form');
    if (!form) return;
    event.preventDefault();

    // El formulario lleva novalidate, asi que el required del <select> es
    // solo semantico: sin esta comprobacion se seguiria enviando size: "",
    // que es justo el fallo que este campo viene a arreglar.
    var sizeField = form.querySelector('[data-palmare-size]');
    var sizeError = form.querySelector('[data-size-error]');
    if (sizeField && !sizeField.value) {
      if (sizeError) sizeError.hidden = false;
      sizeField.focus();
      return;
    }
    if (sizeError) sizeError.hidden = true;

    var modalBody = form.closest('[data-modal-body]');
    var errorMessage = modalBody ? modalBody.querySelector('[data-form-error]') : null;
    var successMessage = modalBody ? modalBody.querySelector('[data-form-success]') : null;
    var submitButton = form.querySelector('[data-submit-button]');
    var originalLabel = submitButton ? submitButton.textContent : '';

    if (errorMessage) errorMessage.hidden = true;
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'ENVIANDO...';
    }

    var formData = new FormData(form);
    var payload = {};
    formData.forEach(function (value, key) {
      payload[key] = value;
    });
    payload.size = getSelectedSize(form);
    payload.type = form.dataset.reservationType;
    payload.source = form.dataset.reservationType === 'restock' ? 'restock' : getSource() || 'guest';

    fetch(resolveWebhookUrl(form), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Webhook responded with status ' + response.status);

        saveContactInfo(payload);
        form.hidden = true;
        if (successMessage) successMessage.hidden = false;

        // Auto-close after the user has had a moment to read the confirmation,
        // so reserving several products in a row doesn't require manually
        // closing each modal before the next one can be opened/clicked.
        var modal = form.closest('modal-dialog');
        if (modal && typeof modal.hide === 'function') {
          setTimeout(function () {
            modal.hide();
          }, 1800);
        }
      })
      .catch(function () {
        if (errorMessage) errorMessage.hidden = false;
      })
      .finally(function () {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalLabel;
        }
      });
  }

  captureSourceFromUrl();

  // Product/collection grids can render this script's <script src> tag once
  // per matching card (one per VIP Drop product shown on the same page), so
  // guard against attaching the submit listener more than once per page —
  // otherwise a single submit would fire N duplicate POSTs to the webhook.
  if (!window.__palmareReservationInit) {
    window.__palmareReservationInit = true;
    document.addEventListener('submit', handleSubmit);
    document.addEventListener('click', handleTriggerClick);
  }
})();
